import React from 'react'
import { Box, Container } from '@mui/material'
import { Children } from '../types/react.types'
import Menu from '../components/Menu'

interface LayoutProps extends Children { }

const Layout = (props: LayoutProps) => {

  const { children } = props

  return (
    <>
      <Menu />
      <Container disableGutters maxWidth="lg" sx={{ color: 'text.primary', backgroundColor: 'background.default', position: 'relative' }}>
        <Box p={2}>
          {children}
        </Box>
      </Container>
    </>
  )
}

export default Layout